import { Box, IconButton, Switch, Tooltip, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment-timezone';
import React from 'react';
import { Link } from 'react-router-dom';
import titleize from 'titleize';
import { ICollectionCreator } from '../../../services/types';
import { getIntervalValueAndPeriodText } from '../../../services/utils';
import useStyles from './styles';
import { CopyToClipboard } from '../../../components/CopyToClipboard';

interface IProps {
  collectionCreators: ICollectionCreator[];
  onClickRow: (automatedCollection: ICollectionCreator) => void;
  onChangeActivation: (automatedCollection: ICollectionCreator) => void;
  onClickDeleteButton: (automatedCollection: ICollectionCreator) => void;
  getLinkUri?: (trackingId: string | undefined) => string;
}

const AutomatedCollectionList = (props: IProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Paper>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell align="center">ID</TableCell>
            <TableCell align="center" size="small" padding="none">
              Tracking ID
            </TableCell>
            <TableCell align="center">Collection Title</TableCell>
            <TableCell align="center">Onboarding?</TableCell>
            <TableCell align="center">Interval Type</TableCell>
            <TableCell align="center">Interval Value/Period</TableCell>
            <TableCell align="center">Next Generation Time</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.collectionCreators.map((ac, idx) => {
            return (
              <TableRow
                component={Link}
                to={props.getLinkUri ? props.getLinkUri(ac.trackingId) : ''}
                key={ac.id}
                hover
                className={classes.tableRow}
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  if (!ac.trackingId) {
                    return;
                  }

                  if (!props.getLinkUri) {
                    e.preventDefault();
                  }

                  props.onClickRow(ac);
                }}
              >
                <TableCell align="center">{ac.id}</TableCell>
                <TableCell align="center" size="small" padding="none">
                  {Boolean(ac.trackingId) && <CopyToClipboard content={ac.trackingId as string} />}
                </TableCell>
                <TableCell>
                  {ac.internalTitle && (
                    <Box display="flex" flexDirection="column">
                      <span className={classes.titleEmphasize}>{ac.internalTitle}</span>
                      <span>{ac.title}</span>
                    </Box>
                  )}
                  {!ac.internalTitle && ac.title}
                </TableCell>
                <TableCell align="center">{ac.isOnboarding ? 'Y' : 'N'}</TableCell>
                <TableCell align="center">{titleize(ac.intervalType)}</TableCell>
                <TableCell align="center">{getIntervalValueAndPeriodText(ac.intervalType, ac.intervalValue, ac.period)}</TableCell>
                <TableCell align="center">{ac.nextAt && moment(ac.nextAt).format('llll')}</TableCell>
                <TableCell align="center">
                  <Tooltip title={ac.isActive ? 'Activated' : 'Deactivated'} placement="bottom">
                    <Switch
                      color="primary"
                      checked={ac.isActive}
                      onClick={e => e.stopPropagation()}
                      onChange={e => {
                        props.onChangeActivation(ac);
                      }}
                      value={idx}
                    />
                  </Tooltip>
                </TableCell>
                <TableCell align="center">
                  <Tooltip title={ac.isActive ? 'You cannot delete it in the active state.' : ''} placement="left-end">
                    <IconButton
                      style={{
                        opacity: ac.isActive ? 0.25 : 1,
                      }}
                      color={ac.isActive ? 'default' : 'primary'}
                      disableFocusRipple={ac.isActive}
                      disableTouchRipple={ac.isActive}
                      disableRipple={ac.isActive}
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onClickDeleteButton(ac);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default AutomatedCollectionList;
